/* eslint-disable max-len */
/**
 * faq页面配置
 */
export default {
  title: 'FAQs',
  content: '',
}
